import gcd from '@/utils/gcd';

import type { PhotoGridItemDimensions } from '../types';

export function getAspectRatioFromDimensions(
  dimensions: PhotoGridItemDimensions,
): PhotoGridItemDimensions {
  // Determine the greatest common divisor between the width and height
  const dimensionsGcd = gcd(dimensions.width, dimensions.height);
  return {
    width: dimensions.width / dimensionsGcd,
    height: dimensions.height / dimensionsGcd,
  };
}
